import { services } from "onearm";
import { BaseGameState } from "onearm";
import { IntroAnimationAct } from "../acts/IntroAnimationAct.js";
import { introSteps } from "../configs/GameIntroConfig.js";
import { symbols } from "../configs/symbols.config.js";

export class GameIntroState extends BaseGameState {
    enter() {
        if (this.data.dontShowAgainGameIntro) {
            this.playGame();
            return;
        }

        this.scene = this.scenes.add("GameIntroScene", {});

        const gameConfig = services.gameConfig;

        this.reels = this.scenes.add("ReelsScene", {
            root: this.scene.getReelsContainer(),
            gameConfig,
            lastSpin: null,
        });

        this.scenes.show("ReelsScene");
        this.scenes.show("GameIntroScene");

        this.introAct = new IntroAnimationAct({
            reelsScene: this.reels,
            steps: introSteps,
            symbols,
        });
        this.introAct.play();

        this.addSignalHandler(this.scene.onPressPlay, this.playGame.bind(this));
        this.addSignalHandler(
            this.scene.onChangeDontShowAgain,
            this.handleDontShowAgain.bind(this),
        );
    }

    playGame() {
        this.owner.goTo("GameState");
    }

    handleDontShowAgain(value) {
        this.data.dontShowAgainGameIntro = value;
    }

    exit() {
        super.exit();

        if (this.introAct) {
            this.introAct.destroy();
            this.introAct = null;
        }

        this.scenes.hide("GameIntroScene");
        this.scenes.remove("ReelsScene");
    }
}
